import { Props } from 'shared/@types';
import { LoginScreen } from 'shared/screens/login';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';
import { withServerProps } from '@web/library/with-server-props';
import { PageBuilder } from 'shared/library/page-builder';
import { useEffectOnce } from 'shared/library/use-effect-once';
import { trackLoginStart } from 'shared/state/login';

export default function Login({}: Props) {
  const { t } = useTranslation('screens');
  useEffectOnce(() => {
    trackLoginStart({ type: 'page', source: 'login-page' });
  });

  return (
    <Page register={(seo) => seo.setTitle(t('login.title'))}>
      <LoginScreen />
    </Page>
  );
}

export const getServerSideProps = withServerProps(
  new PageBuilder().transformProps(({ hasApiKey, props }) => {
    return hasApiKey ? { redirect: { destination: '/', permanent: false } } : props;
  }),
);
